var app = angular.module("nms.dynamicDevice");

/**
 * Verifica se um valor (incluindo números negativos) está contido dentro do intervalo definido pelo yang.
 * Utilizada em campos do tipo number, ou seja, onde o usuário só pode definir um único número para a configuração.
 *
 * @author icaro.damiani
 */
app.directive("yangRangeRestriction", ["RestrictionService", "YangRangeRestrictionService",
    function(RestrictionService, YangRangeRestrictionService) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function(scope, element, attrs, ngModel) {
                var validatorName = RestrictionService.getLeafTypeValidatorName(scope.leaf.type,
                    YangRangeRestrictionService.RESTRICTION_NAME);
                ngModel.$validators[validatorName] = function(modelValue, viewValue) {
                    return YangRangeRestrictionService.validate(modelValue, viewValue, scope.leaf.type);
                };
            }
        };
    }
]);
